import { ToastrService } from 'ngx-toastr';
import { ChangeDetectorRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { BaseComponent } from './base.component';
import * as _ from 'lodash';
export class BaseListComponent extends BaseComponent {
  public data: any = [];
  public modelFilter: any = {};
  public currentPage = 1;
  public page_size = 10;
  public totalItem: any = 0;
  public totalPage: any = 0;
  public lstChecked: any = [];
  public isCheckAll = false;
  public displayColumns: any = [];
  public delete_ids: any = [];
  public delete_id: any;
  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService
  ) {
    super(changeDetector, toastr, modalService);
  }

  public async loadData() {}

  public initPage(total) {
    this.totalItem = total;
    const pageString = (this.totalItem / this.page_size).toString();
    const pageSplit = pageString.split('.');
    let last: any;
    let totalPage = parseInt(pageSplit[0]);
    if (pageSplit.length > 1) {
      last = pageSplit[1];
      if (parseInt(last) > 0) {
        totalPage++;
      }
    }
    this.totalPage = totalPage;
  }

  public async buildBasePayload(request: any = {}, sort?: any) {
    if (!_.isEmpty(this.modelFilter) && _.isEmpty(request)) {
      Object.keys(this.modelFilter).forEach(key => {
        request[key] = this.modelFilter[key];
      });
    }
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }
    return request;
  }
  async changePageLimit(pageSize) {
    this.page_size = Number(pageSize);
    this.currentPage = 1;
    await this.loadData();
  }

  public async setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        await this.loadData();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.throwError('Số trang tối đa hiện tại là ' + page);
      if (page <= this.totalPage) {
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          await this.loadData();
        }
      }
    }
  }
  public goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage).then();
    }
  }
  public checkRow(type: any, key: any, _id?: any) {
    if (type == 'all') {
      if (!this.isCheckAll) {
        this.data.forEach(row => {
          if (!this.lstChecked.includes(row[key])) {
            this.lstChecked.push(row[key]);
          }
        });
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
        this.lstChecked = [];
      }
    }
    if (type == 'row') {
      if (this.lstChecked.includes(_id)) {
        this.lstChecked = this.lstChecked.filter(item => item !== _id);
      } else {
        this.lstChecked.push(_id);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/base-list.component.ts